import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import CustomDatePicker from "../../../../components/Custom-Datepicker";
import Select from "react-select";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { API_URL } from "../../../../constants";
import FileUploaderTne from "../../../../components/FileUploaderTne";
import moment from "moment";
import { toast } from "react-toastify";
import * as Yup from "yup";
import DeleteModal from "../../../../components/DeletePopUpComponent";
import {
  DeleteServiceCaller,
  GetServiceCaller,
  PostFormServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";

const TnEEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("TnE Edit"));
  }, []);

  const initialFormData = {
    ID: "",
    ProjectID: "",
    FromDate: "",
    ToDate: "",
    AdvanceAmountUSD: 0,
    ExchangeRateUSD: 0,
    AdvanceAmountINR: 0,
    ExchangeRateINR:1.00,
    AdvanceAmountBASE: 0,
    attachFile: "",
    BalanceAmountBASE: 0,
    ApprovedAmountBASE: 0,
    AdjustAmountBASE: 0,
    FileName: "",
    MonthID: 0,
    parenttxn: "",
    reimbursementLines: [
      {
        LineNo: 1,
        OnDate: "",
        CategoryID_168: "",
        SubCategoryID_SD168: "",
        Remark: "",
        AmountUSD: "",
        AmountINR: "",
        ApplicationStatus_123: 826,
        SubCategories: "",
      },
    ],
  };

  const [formData, setFormData] = useState(initialFormData);
  console.log("formData",formData);
  
  const [projectList, setProjectList] = useState([]);
  const [categoryOpt, setCategoryOpt] = useState([]);
  const [descriptionOpt, setDescriptionOpt] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [currencySymbol, setCurrencySymbol] = useState("");
  const [projectTXNs, setProjectTXNs] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [rows, setRows] = useState([]);
  const [errors, setErrors] = useState([]);
  const [resumeFile, setResumeFile] = useState([]);
  const [FileName, setFileName] = useState([]);
  const [fileAttachment, SetFileAttachment] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [deductedCheck, setDeductedCheck] = useState(false);

  useEffect(() => {
    if (id) {
      fetchTne(id);
    }
  }, []);

  const fetchTne = async (id) => {
    const response = await GetServiceCaller(
      `${API_URL}payroll/reimbursements/team-reimbursements/${id}`
    );
    if (response.status === 200) {
      const fetchData = response?.data?.data?.tneList;
      const fetchLineData = response?.data?.data?.tneSubList;
      const attachment = response?.data?.data?.FilePath;
      SetFileAttachment(attachment);
      // Extract SubCategories data
      const subCategoriesArray = fetchLineData.map(
        (item) => item.SubCategories
      );
      console.log("subCategoriesArray", subCategoriesArray);

      const optionsub = subCategoriesArray.map((item) => ({
        value: item.value,
        label: item.text,
      }));

      // Map through fetchLineData to create the Lines array
      const Lines = fetchLineData.map((item) => ({
        ID: item.ID,
        TXNID: item.TXNID,
        LineNo: item.LineNo,
        OnDate: moment(item.OnDate).format("DD-MMM-YYYY"),
        CategoryID_168: item.CategoryID_168,
        SubCategoryID_SD168: item.SubCategoryID_SD168,
        Remark: item.Remark,
        AmountUSD: item.AmountUSD,
        AmountINR: item.AmountINR,
        SubCategories: item.SubCategories,
      }));

      // Create form data object
      const formDataEdit = {
        ID: fetchData?.ID,
        ProjectID: fetchData.ProjectID,
        FromDate: moment(fetchData?.FromDate).format("DD-MMM-YYYY"),
        ToDate: moment(fetchData?.ToDate).format("DD-MMM-YYYY"),
        AdvanceAmountUSD: fetchData.AdvanceAmountUSD,
        AdvanceAmountINR: fetchData.AdvanceAmountINR,
        FileName: fetchData.FileName,
        ExchangeRateUSD: fetchData.ExchangeRateUSD,
        ExchangeRateINR: fetchData.ExchangeRateINR,
        reimbursementLines: Lines,
        attachFile:[]
      };

      // Set form data
      setFormData(formDataEdit);
    } else {
      console.error(
        "Failed to fetch model masters. Server responded with status:",
        response.status
      );
    }
  };

  useEffect(() => {
    if (formData?.ProjectID) {
      fetchProjectDetails(formData?.ProjectID);
    }
  }, [formData.ProjectID]);

  const fetchProjectDetails = async (selectedValue) => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}payroll/reimbursements/project/currency?ProjectID=${selectedValue}`
      );

      if (response.status === 200) {
        const data = response?.data?.data;
        const projectTXNs = data.map((item) => item.TXNs);
        setProjectTXNs(projectTXNs);
        
        const nonINRCurrencies = data?.filter(
          (item) => item.CurrencySymbol !== "Rs."
        );
        const Symbol = nonINRCurrencies?.map((item) => item.CurrencySymbol);
        setCurrencySymbol(Symbol);
        const projectIDs = data.map((item) => item.IDs);

        setFormData((prevFormData) => ({
          ...prevFormData,
          parenttxn: projectIDs,
        }));
      }
    } catch (error) {
      console.error("Error calling API:", error);
    }
  };

  const handleInputChange = (rowIndex, field, value) => {
    const updatedReimbursementLines = [...formData.reimbursementLines];
    updatedReimbursementLines[rowIndex][field] = value;
    setFormData({ ...formData, reimbursementLines: updatedReimbursementLines });
  };

  const fetchTnE = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}payroll/reimbursements/new-TnE`
      );

      // Project Options
      const TnE = response?.data?.data?.projectList;
      const projectOpt = TnE.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setProjectList(projectOpt);

      // Category Options
      const categoryList = response?.data?.data?.categoryList;
      const CategoryOptions = categoryList.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setCategoryOpt(CategoryOptions);
    } catch (error) {
      console.error("Error fetching TnE:", error);
    }
  };

  useEffect(() => {
    fetchTnE();
  }, []);

  const handleDeleteClose = () => {
    setShowDeleteModal(false);
    setSelectedDeleteItem(null);
  };

const handleSelect1Change = async (value, rowIndex) => {
  try {
    // Update rows state
    setRows(prevRows => 
      prevRows.map((r, i) => (i === rowIndex ? { ...r, select1: value } : r))
    );

    // Clear descriptions
    setDescriptionOpt([]);

    // Update formData state in a single operation to avoid multiple re-renders
    setFormData(prevFormData => {
      const updatedReimbursementLines = prevFormData.reimbursementLines.map((line, i) => 
        i === rowIndex 
          ? { 
              ...line, 
              CategoryID_168: value.value,
              SubCategoryID_SD168: null  // Clear subcategory when category changes
            } 
          : line
      );

      return {
        ...prevFormData,
        reimbursementLines: updatedReimbursementLines
      };
    });

    // Fetch descriptions
    await fetchDescriptionAPI(value.value, rowIndex);

    // Validate field
    await validateField("CategoryID_168", {
      CategoryID_168: value.value,
    });

    // Clear error if exists
    if (errors?.[`reimbursementLines[${rowIndex}].CategoryID_168`]) {
      setErrors(prevErrors => {
        const newErrors = { ...prevErrors };
        delete newErrors[`reimbursementLines[${rowIndex}].CategoryID_168`];
        return newErrors;
      });
    }
  } catch (error) {
    console.error("Error in handleSelect1Change:", error);
    // Handle error appropriately
  }
};
  // const handleSelect2Change = (value, rowIndex) => {
  //   setRows(
  //     rows.map((r, i) => (i === rowIndex ? { ...r, select2: value } : r))
  //   );

  //   // Update SubCategoryID_SD168 in reimbursementLines
  //   const updatedReimbursementLines = [...formData.reimbursementLines];
  //   updatedReimbursementLines[rowIndex] = {
  //     ...updatedReimbursementLines[rowIndex],
  //     SubCategoryID_SD168: value.value,
  //   };
  //   setFormData({ ...formData, reimbursementLines: updatedReimbursementLines });
  // };
  const handleSelect2Change = (value, rowIndex) => {
    setRows(
      rows.map((r, i) => (i === rowIndex ? { ...r, select2: value } : r))
    );

    // Update SubCategoryID_SD168 in reimbursementLines
    const updatedReimbursementLines = [...formData.reimbursementLines];
    updatedReimbursementLines[rowIndex] = {
      ...updatedReimbursementLines[rowIndex],
      SubCategoryID_SD168: value.value,
    };
    setFormData({ ...formData, reimbursementLines: updatedReimbursementLines });

    // Remove error for the selected SubCategoryID_SD168 field
    const updatedErrors = { ...errors };
    delete updatedErrors[`reimbursementLines[${rowIndex}].SubCategoryID_SD168`];
    setErrors(updatedErrors);
  };

  const getSubCategories = (options) => {
    let optionsub;
    if (typeof options != "string") {
      optionsub = options?.map((item) => ({
        value: item.value,
        label: item.text,
      }));
    }
    return optionsub;
  };

  const fetchDescriptionAPI = async (selectedValue, index) => {
    console.log("selectedValue", index);

    try {
      const response = await GetServiceCaller(
        `${API_URL}payroll/reimbursements/get-category-list?CategoryID=${selectedValue}`
      );

      if (response?.status === 200) {
        console.log("API Response:", response?.data);

        const description = response?.data?.data;
        console.log("description", description);

        const descriptionOpt = description.map((item) => ({
          value: item.value,
          label: item.text,
        }));
        setDescriptionOpt(descriptionOpt);
      } else {
        console.error(
          `Failed to fetch descriptions. Status: ${response?.status}`
        );
      }
    } catch (error) {
      console.error("Error fetching descriptions:", error);
    }
  };

  const handleProjectChange = async (selectedOption, name) => {
    setSelectedProject(selectedOption);
    setFormData({
      ...formData,
      ProjectID: selectedOption ? selectedOption.value : "",
    });
    await validateField(name, selectedOption.value);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  // const handleDateChange = (date, rowIndex) => {
  //   const updatedReimbursementLines = [...formData.reimbursementLines];
  //   updatedReimbursementLines[rowIndex].OnDate = date.target.value;
  //   setFormData({ ...formData, reimbursementLines: updatedReimbursementLines });
  // };

  const handleDateChange = (date, rowIndex) => {
    const updatedReimbursementLines = [...formData.reimbursementLines];
    updatedReimbursementLines[rowIndex].OnDate = date.target.value;
    const updatedErrors = { ...errors };
    delete updatedErrors[`reimbursementLines[${rowIndex}].OnDate`];

    setFormData({ ...formData, reimbursementLines: updatedReimbursementLines });
    setErrors(updatedErrors);
  };

  const schema = Yup.object().shape({
    ProjectID: Yup.string().required("Project is required"),
    reimbursementLines: Yup.array().of(
      Yup.object().shape({
        CategoryID_168: Yup.number()
          .typeError("Category is Required")
          .required("Category is required"),
        SubCategoryID_SD168: Yup.number()
          .typeError("Description is required")
          .required("Description is required"),
        OnDate: Yup.date()
          .typeError("Date is required")
          .nullable()
          .required("Date is required"),
      })
    ),
  });
  const validateField = async (fieldName, updatedData) => {
    try {
      await schema.validateAt(fieldName, updatedData);
      setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: "" }));
    } catch (err) {
      if (err.path === fieldName) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [fieldName]: err.message,
        }));
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Prepare the formData to ensure `0` is passed for disabled fields
    const updatedLines = formData.reimbursementLines.map((line) => ({
      ...line,
      AmountUSD:
        line.AmountINR && parseFloat(line.AmountINR) > 0
          ? "0"
          : line.AmountUSD || "0",
      AmountINR:
        line.AmountUSD && parseFloat(line.AmountUSD) > 0
          ? "0"
          : line.AmountINR || "0",
    }));

    // Calculate AdvanceAmountBASE before submission
    const AdvanceAmountBASE = (
      parseFloat(formData?.AdvanceAmountUSD || 0) *
        parseFloat(formData?.ExchangeRateUSD || 1) +
      parseFloat(formData?.AdvanceAmountINR || 0) *
        parseFloat(formData?.ExchangeRateINR || 1)
    ).toFixed(2);

    // Calculate BalanceAmountBASE (subtracting reimbursement total from AdvanceAmountBASE)
    const reimbursementAmountUSD = updatedLines.reduce(
      (sum, line) => sum + (parseFloat(line.AmountUSD) || 0),
      0
    );
    const reimbursementAmountINR = updatedLines.reduce(
      (sum, line) => sum + (parseFloat(line.AmountINR) || 0),
      0
    );

    const reimbursementTotal = (
      reimbursementAmountUSD * (parseFloat(formData?.ExchangeRateUSD) || 1) +
      reimbursementAmountINR
    ).toFixed(2);

    const BalanceAmountBASE = (
      parseFloat(AdvanceAmountBASE) - parseFloat(reimbursementTotal)
    ).toFixed(2);

    // Add AdvanceAmountBASE and BalanceAmountBASE to formData
    const updatedFormData = {
      ...formData,
      reimbursementLines: updatedLines,
      AdvanceAmountBASE,
      BalanceAmountBASE,
      AdjustAmountBASE: "0",
      ApprovedAmountBASE: "0",
    };


    console.log("updatedFormData",updatedFormData);
    

    try {
      console.log(updatedFormData); // Log the updated form data
      await schema.validate(updatedFormData, { abortEarly: false });
      setErrors({});

      // Make a POST request to your API endpoint with updatedFormData
      const response = await PostFormServiceCaller(
        `${API_URL}payroll/reimbursements/new-TnE/${formData.ID}`,
        updatedFormData,
        "put"
      );

      // Handle success
      console.log("API Response:", response.data);
      toast.success("Data submitted successfully!");
      setFormData({});
      setTimeout(() => {
        navigate("/my-reimbursements/report");
      }, 2000);
    } catch (error) {
      if (error.name === "ValidationError") {
        console.error("Validation Error:", error);
        const validationErrors = {};
        error.inner.forEach((err) => {
          validationErrors[err.path] = err.message;
        });
        setErrors(validationErrors);

        // Display validation errors related to the 'lines' field using toast
        Object.keys(validationErrors).forEach((field) => {
          if (field.startsWith("lines")) {
            toast.error(validationErrors[field], { position: "top-right" });
          }
        });
      } else {
        console.error("Unexpected Error:", error);
      }
    }
  };

  //  new code

  const handleAddLine = async () => {
    // Check if at least one row is added
    if (formData.reimbursementLines.length === 0) {
      // Add the first row
      setFormData((prevState) => ({
        ...prevState,
        reimbursementLines: [
          ...prevState.reimbursementLines,
          {
            LineNo: 1,
            OnDate: "",
            CategoryID_168: "",
            SubCategoryID_SD168: "",
            Remark: "",
            AmountUSD: "",
            AmountINR: "",
            ApplicationStatus_123: "",
          },
        ],
      }));
    } else {
      const invalidRow = formData.reimbursementLines.find(
        (row) => !row.OnDate || !row.CategoryID_168 || !row.SubCategoryID_SD168
      );

      if (invalidRow) {
        toast.error(
          "Please fill all required fields in Previous Row before adding a new one."
        );
        return;
      }
      setFormData((prevState) => {
        const nextLineNo = prevState.reimbursementLines.length + 1;
        return {
          ...prevState,
          reimbursementLines: [
            ...prevState.reimbursementLines,
            {
              LineNo: nextLineNo,
              OnDate: "",
              CategoryID_168: "",
              SubCategoryID_SD168: "",
              Remark: "",
              AmountUSD: "",
              AmountINR: "",
              ApplicationStatus_123: "",
            },
          ],
        };
      });
    }
  };

  const handleDeleteRow = (index) => {
    setFormData((prevState) => ({
      ...prevState,
      reimbursementLines: prevState.reimbursementLines.filter(
        (_, rowIndex) => rowIndex !== index
      ),
    }));
  };
  const handleDelete = (item) => {
    setSelectedDeleteItem(item);
    setShowDeleteModal(true);
  };
  const handleCancel = () => {
    navigate("/my-reimbursements/report");
  };

  const AdvanceAmountBASE = (
    parseFloat(formData?.AdvanceAmountUSD || 0) *
      parseFloat(formData?.ExchangeRateUSD || 1) +
    parseFloat(formData?.AdvanceAmountINR || 0) *
      parseFloat(formData?.ExchangeRateINR || 1)
  ).toFixed(2);

  const reimbursementAmountUSD = formData?.reimbursementLines?.reduce(
    (sum, line) => sum + (parseFloat(line.AmountUSD) || 0),
    0
  );
  const reimbursementAmountINR = formData?.reimbursementLines?.reduce(
    (sum, line) => sum + (parseFloat(line.AmountINR) || 0),
    0
  );

  // Calculate the total amount to subtract (in BalanceAmountBASE)
  const reimbursementTotal = (
    reimbursementAmountUSD * (parseFloat(formData?.ExchangeRateUSD) || 1) +
    reimbursementAmountINR
  ).toFixed(2);

  const BalanceAmountBASE = (
    parseFloat(AdvanceAmountBASE) - parseFloat(reimbursementTotal)
  ).toFixed(2);

  const handleFile = (file) => {
    if (file) {
      // Clear any previous error messages
      setErrors((prevErrors) => ({
        ...prevErrors,
        attachFile: "",
      }));

      // Update form data and resume file state
      setFileName(file.name);
      setFormData((prevState) => ({
        ...prevState,
        attachFile: file,
        FileName:file.name
      }));
      setResumeFile(file);
    } else {
      // Set an error message if file is invalid
      setErrors((prevErrors) => ({
        ...prevErrors,
        attachFile:
          "File size should not exceed 1MB and must be a PDF or Word document.",
      }));
    }
  };

  const handleModalDelete = () => {
    if (selectedDeleteItem) {
      {
        handleDeleteLine(selectedDeleteItem?.LineNo, selectedDeleteItem?.TXNID);
      }
      setShowDeleteModal(false);
      setSelectedDeleteItem(null);
    }
  };
  const handleDeleteLine = async (LineNo, TXNID) => {
    console.log("Deleting Line:", { LineNo, TXNID });

    if (!TXNID) {
      console.warn("TXNID is required for deletion.");
      return;
    }

    try {
      const queryParams = new URLSearchParams({
        TXNID: TXNID,
        LineNo: LineNo,
      }).toString();
      const response = await DeleteServiceCaller(
        `${API_URL}payroll/reimbursements/new-TnE/${formData.ID}?${queryParams}`,
        {},
        "delete"
      );
      // Check if the response status indicates success
      if (response?.status === 200) {
        toast.success("Data deleted successfully.");
        // window.location.reload();
        fetchTne(id);
      } else {
        toast.error(
          `Failed to delete data. Status: ${response?.status || "Unknown"}`
        );
      }
    } catch (error) {
      console.error("Error occurred while deleting the row:", error);
      toast.error("An error occurred while trying to delete the data.");
    }
  };

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <form onSubmit={handleSubmit}>
            <div>
              <div className="row">
                <div className="col-md-2">
                  <div class="mb-3">
                    <label for="Code" class="form-label">
                      Project<span className="required">*</span>
                    </label>
                    <Select
                      //   value={selectedProject}
                      value={projectList.find(
                        (opt) => opt.value === formData.ProjectID
                      )}
                      options={projectList}
                      name="ProjectID"
                      isDisabled
                      onChange={(selectedOption, action) =>
                        handleProjectChange(selectedOption, action.name)
                      }
                    />
                    {errors.ProjectID && (
                      <div className="text-danger">{errors.ProjectID}</div>
                    )}
                  </div>
                </div>
                <div className="col-md-2">
                  <div class="mb-3">
                    <label for="Code" class="form-label">
                      From Date<span className="required">*</span>
                    </label>
                    <CustomDatePicker
                      handleChange={handleChange}
                      value={formData.FromDate}
                      name="FromDate"
                      id="FromDate"
                      className="form-control disable"
                      placeholderText="DD-MM-YYYY"
                      maxDate={new Date()}
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div class="mb-3">
                    <label for="Code" class="form-label">
                      To Date<span className="required">*</span>
                    </label>
                    <CustomDatePicker
                      handleChange={handleChange}
                      value={formData.ToDate}
                      name="ToDate"
                      id="ToDate"
                      className="form-control"
                      placeholderText="DD-MM-YYYY"
                      maxDate={new Date()}
                    />
                  </div>
                </div>
              </div>
            </div>

            <hr class="border-2 border-top mt-0 border-black" />
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "15px",
                marginBottom: "10px",
              }}
            >
              {projectTXNs.map((txn, index) => (
                <div
                  key={index}
                  style={{
                    backgroundColor: "#00C0EF",
                    padding: "2px",
                    borderRadius: "20px",
                    color: "white",
                  }}
                >
                  <span>
                    <div dangerouslySetInnerHTML={{ __html: txn }} />
                  </span>
                </div>
              ))}
            </div>

            <Table bordered>
              <thead id="thcolor" className="text-center">
                <tr>
                  <td scope="col" class="col-1">
                    #
                  </td>
                  <td scope="col" class="col-2">
                    {" "}
                    Date<span className="required">*</span>
                  </td>
                  <td scope="col" class="col-2">
                    Category<span className="required">*</span>
                  </td>
                  <td scope="col" class="col-2">
                    Description<span className="required">*</span>
                  </td>
                  <td>Remark</td>
                  <td>
                    Amt. ({currencySymbol})<span className="required">*</span>
                  </td>
                  <td>
                    Amt. (&#8377;)<span className="required">*</span>
                  </td>
                  <td>Base Amt. (&#8377;)</td>
                  <td>Action</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td className="text-end">
                    <b>Advance Amt. :</b>
                  </td>
                  <td>
                    <input
                      type="text"
                      placeholder="0.00"
                      disabled
                      className="form-control text-end"
                      name="AdvanceAmountUSD"
                      value={formData.AdvanceAmountUSD}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      placeholder="0.00"
                      disabled
                      className="form-control text-end"
                      name="AdvanceAmountINR"
                      value={formData.AdvanceAmountINR}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      disabled
                      placeholder="0.00"
                      className="form-control text-end"
                      name="AdvanceAmountBASE"
                      value={AdvanceAmountBASE}
                    />
                  </td>
                </tr>
                {formData?.reimbursementLines?.map((line, index) => {
                  const calculatedAmountINR = parseFloat(
                    (line?.AmountUSD || 0) *
                      (parseFloat(formData?.ExchangeRateUSD) || 1)
                  ).toFixed(2);
                  return (
                    <tr key={index}>
                      <td className="text-center">{index + 1}</td>
                      <td>
                        <CustomDatePicker
                          handleChange={(date) => handleDateChange(date, index)}
                          value={line.OnDate}
                          name="OnDate"
                          id="OnDate"
                          className={`form-control ${
                            errors?.[`reimbursementLines[${index}].OnDate`]
                              ? "is-invalid"
                              : ""
                          }`}
                          placeholderText="DD-MM-YYYY"
                          minDate={formData?.FromDate || null}
                          maxDate={new Date(formData?.ToDate) || null}
                        />
                        {errors?.[`reimbursementLines[${index}].OnDate`] && (
                          <span className="error">
                            {errors[`reimbursementLines[${index}].OnDate`]}
                          </span>
                        )}
                      </td>
                      <td>
                        <Select
                          value={categoryOpt.find(
                            (opt) => opt.value === line.CategoryID_168
                          )}
                          options={categoryOpt}
                          onChange={(value) =>
                            handleSelect1Change(value, index, "CategoryID_168")
                          }
                          className={`${
                            errors?.[
                              `reimbursementLines[${index}].CategoryID_168`
                            ]
                              ? "is-invalid"
                              : ""
                          }`}
                          name="CategoryID_168"
                        />
                        {errors?.[
                          `reimbursementLines[${index}].CategoryID_168`
                        ] && (
                          <span className="error">
                            {
                              errors[
                                `reimbursementLines[${index}].CategoryID_168`
                              ]
                            }
                          </span>
                        )}
                      </td>
                      <td>
                 <Select
  value={
    (
      (descriptionOpt?.length ? descriptionOpt : getSubCategories(line.SubCategories)) || []
    ).find(opt => opt.value === line.SubCategoryID_SD168) || null
  }
  name="SubCategoryID_SD168"
  options={
    descriptionOpt?.length
      ? descriptionOpt
      : getSubCategories(line.SubCategories) || []
  }
  className={
    errors?.[`reimbursementLines[${index}].SubCategoryID_SD168`] 
      ? "is-invalid" 
      : ""
  }
  onChange={(value) => handleSelect2Change(value, index)}
  placeholder="Select Subcategory"
  isClearable
/>

                        {errors?.[
                          `reimbursementLines[${index}].SubCategoryID_SD168`
                        ] && (
                          <span className="error">
                            {
                              errors[
                                `reimbursementLines[${index}].SubCategoryID_SD168`
                              ]
                            }
                          </span>
                        )}
                      </td>
                      <td>
                        <input
                          type="text"
                          placeholder="Remark"
                          className="form-control text-end"
                          value={line.Remark}
                          onChange={(e) =>
                            handleInputChange(index, "Remark", e.target.value)
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          placeholder="0.00"
                          className="form-control text-end"
                          value={line.AmountUSD}
                          disabled={
                            line?.AmountINR && parseFloat(line?.AmountINR) > 0
                          }
                          onChange={(e) =>
                            handleInputChange(
                              index,
                              "AmountUSD",
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          placeholder="0.00"
                          className="form-control text-end"
                          value={line.AmountINR}
                          disabled={
                            line?.AmountUSD && parseFloat(line?.AmountUSD) > 0
                          }
                          onChange={(e) =>
                            handleInputChange(
                              index,
                              "AmountINR",
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          placeholder="0.00"
                          className="form-control text-end"
                          value={
                            calculatedAmountINR != 0.0
                              ? calculatedAmountINR
                              : line.AmountINR
                          }
                          disabled
                        />
                      </td>

                      <td>
                        <div
                          type="button"
                          // onClick={() => handleDeleteRow(index)}
                          onClick={() => handleDelete(line)}
                          className="text-center"
                        >
                          <i
                            className="bi bi-trash"
                            style={{ fontSize: "1.2rem" }}
                          ></i>
                        </div>
                      </td>
                    </tr>
                  );
                })}

                <tr>
                  <td>
                    <button
                      className="custom-btn"
                      onClick={(e) => {
                        e.preventDefault();
                        handleAddLine();
                      }}
                    >
                      <i className="bi bi-plus-lg"></i>Add
                    </button>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td className="text-end">
                    <b>Total:</b>
                  </td>
                  <td className="text-end">
                    <div>
                      <b>
                        {Array.isArray(formData?.reimbursementLines)
                          ? formData.reimbursementLines
                              .reduce(
                                (sum, line) =>
                                  sum + (parseFloat(line?.AmountUSD) || 0),
                                0
                              )
                              .toFixed(2)
                          : "0.00"}
                      </b>
                    </div>
                    <div>
                      <p>(ER:{formData?.ExchangeRateUSD})</p>
                    </div>
                  </td>
                  <td className="text-end">
                    <div>
                      <b>
                        {formData?.reimbursementLines
                          ?.reduce(
                            (sum, line) =>
                              sum + (parseFloat(line.AmountINR) || 0),
                            0
                          )
                          .toFixed(2)}
                      </b>
                    </div>
                    <div>
                      <p>(ER:{formData?.ExchangeRateINR})</p>
                    </div>
                  </td>
                  <td className="text-end">
                    <div>
                      <b>
                        {(
                          formData?.reimbursementLines?.reduce(
                            (sum, line) =>
                              sum + (parseFloat(line.AmountUSD) || 0),
                            0
                          ) *
                            (parseFloat(formData?.ExchangeRateUSD) || 1) +
                          formData?.reimbursementLines?.reduce(
                            (sum, line) =>
                              sum + (parseFloat(line.AmountINR) || 0),
                            0
                          )
                        ).toFixed(2)}
                      </b>
                    </div>
                    <div>
                      <p>(ER:1.00)</p>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan="3" rowspan="3">
                    <div className="col-md-12">
                      <FileUploaderTne handleFile={handleFile} />
                      <div className="mb-0">
                        <p>
                          <a target="_blank" href={fileAttachment}>
                            {FileName != "" ? FileName : formData?.FileName}
                          </a>
                        </p>
                      </div>
                    </div>
                  </td>
                  <td className="mt-2">
                    {BalanceAmountBASE >= 0 && (
                      <div className="d-flex gap-1 mt-2">
                        <div>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="IsDeductFromSalary"
                            checked={formData.IsDeductFromSalary === 1}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                IsDeductFromSalary: e.target.checked ? 1 : 0,
                              })
                            }
                          />
                        </div>
                        <label className="col-sm-12">
                          <b>Deduct From Salary</b>
                        </label>
                      </div>
                    )}
                  </td>
                  <td></td>
                  <td colspan="3" rowspan="2">
                    {/* <div className="row">
                      <label className="col-sm-4 mt-2">
                        <b>
                          Approved Amt (&#8377;)
                          <span className="required">*</span>
                        </b>
                      </label>
                      <div className="col-sm-8">
                        <input
                          type="text"
                          className="form-control text-end"
                          disabled
                          placeholder="0.00"
                          name=""
                        />
                      </div>
                    </div> */}
                    {/* <div className="row mt-2">
                      <label className="col-sm-4 mt-2">
                        <b>
                          Adjusted Amt (&#8377;)
                          <span className="required">*</span>
                        </b>
                      </label>
                      <div className="col-sm-8">
                        <input
                          type="text"
                          className="form-control text-end"
                          disabled
                          placeholder="0.00"
                          name="AdjustAmountBASE"
                          value={formData.AdjustAmountBASE}
                        />
                      </div>
                    </div> */}
                    <div className="row mt-2">
                      <label className="col-sm-4 mt-2">
                        <b>
                          Balance Amt. (&#8377;)
                          <span className="required">*</span>
                        </b>
                      </label>
                      <div className="col-sm-8">
                        <input
                          type="text"
                          className="form-control text-end"
                          disabled
                          placeholder="0.00"
                          name="BalanceAmountBASE"
                          value={BalanceAmountBASE}
                        />
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </Table>
            <div className="text-end">
              <button className="cancel-btn me-2" onClick={handleCancel}>
                Cancel
              </button>
              <button type="submit" className="custom-btn">
                Submit
              </button>
            </div>
          </form>
        </div>
        <DeleteModal
          show={showDeleteModal}
          onClose={handleDeleteClose}
          onConfirm={handleModalDelete}
          message="Are you sure you want to delete this item?"
        />
      </div>
    </>
  );
};

export default TnEEdit;
